export default __webpack_public_path__ + "static/media/card_reseller_template.b93d05c9.jpeg";